import { createContext, useContext } from 'react';

/**
 * Context for container nesting level.
 * Used to apply level-based styling (typography, gaps) to container contents.
 *
 * Levels:
 * - 1: Root level (largest typography, gap-subsection)
 * - 2: Section level (medium typography, gap-section-subsection)
 * - 3: Deepest level (smallest typography, gap-section-subsection)
 *
 * Max level is capped at 3 - deeper nesting uses level 3 styling.
 */
export const ContainerLevelContext = createContext<number>(1);

/**
 * Hook to get the current container level from context.
 * Returns 1 as default if no provider is found.
 */
export const useContainerLevel = (): number => {
  return useContext(ContainerLevelContext);
};
